import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/topImg/time.png'


const _withScopeId = n => (_pushScopeId("data-v-39d65322"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bf6f6f8" }
const _hoisted_2 = { class: "contentWarp" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-laba c2577E3 fz14 relative",
  style: {"top":"2px"}
}, " ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "64",
  height: "19",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cccc relative",
  style: {"top":"1px"}
}, " | ", -1))
const _hoisted_6 = { class: "c666 fz14 lh40 pl5" }
const _hoisted_7 = { class: "c999 pl5 fz12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-kefu fz20 fbold" }, " ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fz12 c666 pl5 pr5" }, "服务热线", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fbold fz18" }, "400-8061633", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createBlock(_component_el_affix, { offset: 0 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                class: "flex align_item"
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_carousel, {
                    height: "35px",
                    direction: "vertical",
                    autoplay: true,
                    "indicator-position": "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.informationList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: { path: '/informationDetail', query: { id: item.id } }
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_6, [
                                  _createTextVNode(_toDisplayString(item.title), 1),
                                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.parseData(item.publishDate)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "flex align_item justify_right"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}